import React, { useState } from 'react';

import { getPriceString } from '@stencil/flights-utils/src/srp-thor-utils';

import { SpinnerLoader } from '../common-elements.styles';

import ArrowDownIcon from '../../../icons/ArrowDown';

import * as S from './bagCancelRules.styles';
import { ICON_BASE_URL } from '@stencil/flights-constants';

const RulesBlock = ({ rulesData, vcData = [], isDomRT = false }) => {
  return (
    <S.CancellationBlock isDomRT={isDomRT}>
      <div className="f500 marginB10">{rulesData.name}</div>
      <S.Cstable>
        {Object.keys(rulesData?.value).map(key => {
          const name = rulesData.value[key].name;
          let value = rulesData.value[key].value;

          return (
            <S.Csrow key={key}>
              <S.Cscell isDomRT={isDomRT} cp header={key === 'th'}>
                <span>{name}</span>
              </S.Cscell>
              <S.Cscell isDomRT={isDomRT} cp header={key === 'th'}>
                {isNaN(value) ? value : <>₹{getPriceString(value)}</>}
              </S.Cscell>
            </S.Csrow>
          );
        })}
      </S.Cstable>

      {(vcData && vcData.length && (
        <S.Cstable className="marginT10">
          {vcData.map(vcItem => (
            <S.Csrow>
              <S.Cscell isDomRT={isDomRT} cp>
                <p dangerouslySetInnerHTML={{ __html: vcItem.name }}></p>
              </S.Cscell>
              <S.Cscell isDomRT={isDomRT} cp>
                {isNaN(vcItem.value) ? (
                  vcItem.value
                ) : (
                  <p dangerouslySetInnerHTML={{ __html: `₹${getPriceString(vcItem.value)}` }}></p>
                )}
              </S.Cscell>
            </S.Csrow>
          ))}
        </S.Cstable>
      )) ||
        null}
    </S.CancellationBlock>
  );
};

const CancellationDetailsBlock = ({ data, isDomesticRoundTrip = false }) => {
  const { cp: cancellationData = {}, rp: rescheduleData = {}, vc: vcData = [] } = data;
  return (
    <S.CancellationWrap isDomRT={isDomesticRoundTrip} className="dF justifyBetween">
      {cancellationData &&
        cancellationData.value &&
        Object.keys(cancellationData.value).length > 0 && (
          <RulesBlock rulesData={cancellationData} vcData={vcData} isDomRT={isDomesticRoundTrip} />
        )}
      {rescheduleData && rescheduleData.value && Object.keys(rescheduleData.value).length > 0 && (
        <RulesBlock rulesData={rescheduleData} isDomRT={isDomesticRoundTrip} />
      )}
    </S.CancellationWrap>
  );
};

const CancellationDetails = ({
  data,
  showDetailsFlag,
  isDomesticRoundTrip = false,
  isCollapsable = true
}) => {
  const [showDetails, setShowDetails] = useState(showDetailsFlag || false);

  const {
    wr_bg_clr: wrBgClr = [],
    fc: fontClr = '',
    wr: refundability = '',
    c: carriers = [],
    //cr: carrier = '',
    hd: header = '',
    lh: layoverHeader = ''
  } = data;

  return (
    <S.PolicyWrap cnclPolicy>
      <S.CnclPolicySubHd className="dF justifyBetween">
        <span className="dF alignItemsCenter">
          <S.ImgWrapper className="marginR8">
            {carriers.map((carrier, index) => (
              <img
                key={index}
                src={`${ICON_BASE_URL}v2/app-img/${carrier}.webp`}
                width="24"
                height="24"
              />
            ))}
          </S.ImgWrapper>

          <div className="dF flexCol">
            <span
              className={`${isDomesticRoundTrip ? '' : 'font14'} marginR5`}
              dangerouslySetInnerHTML={{ __html: header }}
            ></span>
            {(layoverHeader && <span className="greyCnt">{layoverHeader}</span>) || null}
          </div>
        </span>
        <span className="dF" onClick={() => setShowDetails(!showDetails)}>
          <S.RefundTag
            bgColor={wrBgClr}
            fontColor={fontClr}
            className={`${isDomesticRoundTrip ? '' : 'font14'} f500`}
          >
            {refundability}
          </S.RefundTag>
          {(isCollapsable && (
            <S.ArrowWrap className="marginL10 curPointFlt">
              <ArrowDownIcon
                width="1rem"
                height="1rem"
                className={`${showDetails ? 'downArw' : ''}`}
              />
            </S.ArrowWrap>
          )) ||
            null}
        </span>
      </S.CnclPolicySubHd>

      {showDetails && (
        <CancellationDetailsBlock data={data} isDomesticRoundTrip={isDomesticRoundTrip} />
      )}
    </S.PolicyWrap>
  );
};

const CancellationRules = ({
  cancellationData,
  showDetails = false,
  isDomesticRoundTrip = false,
  isCollapsable = true
}) => {
  if (!cancellationData) {
    return (
      <div className="padT20">
        <SpinnerLoader />
      </div>
    );
  }
  const { terms } = cancellationData;
  return (
    <S.PolicyBody isDomRT={isDomesticRoundTrip || false} id="cancellation_policy">
      {Object.keys(terms).map(sector => {
        return (
          <CancellationDetails
            data={terms[sector]}
            showDetailsFlag={showDetails}
            isDomesticRoundTrip={isDomesticRoundTrip}
            isCollapsable={isCollapsable}
          />
        );
      })}
    </S.PolicyBody>
  );
};

export default CancellationRules;
